import React from 'react';
import SolutionScheduleWrapper from 'components/SolutionScheduleWrapper/SolutionScheduleWrapper';

export default function SolutionScheduleContainer() {
    return (
        <SolutionScheduleWrapper />
    )
}
